import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { selectFilters } from "slices/captureDashboard";
import createExportThunk from "slices/captureDashboard/createExportThunk";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/opportunity-to-proposal";

export const fetchOpportunityToProposal = createAsyncThunk(
  "opportunityToProposal/fetch",
  async (_, { getState }) => {
    const filters = selectFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd },
    });
    return data;
  }
);

export const exportOpportunityToProposalCsv = createExportThunk(
  BASE_URL,
  "csv",
  "Opportunity to Proposal.csv"
);

export const exportOpportunityToProposalPdf = createExportThunk(
  BASE_URL,
  "pdf",
  "Opportunity to Proposal.pdf"
);
